{
  "language": {
    "title": "Àyàn èdè",
    "subtitle": "Yan èdè tí o fẹ́ lò.",
    "saved": "A ti fi èdè pamọ́.",
    "apply": "Lò ó",
    "fr": "Faransé",
    "en": "Gẹ̀ẹ́sì",
    "fon": "Fọ̀n",
    "yo": "Yorùbá",
    "bba": "Baríbà",
    "partial": "Apá kan"
  },
  "common": {
    "cancel": "Fagilé",
    "save": "Fi pamọ́",
    "retry": "Tún gbìyànjú",
    "back": "Padà",
    "next": "Tẹ̀síwájú",
    "close": "Tì",
    "search": "Wá",
    "delete": "Paarẹ́",
    "edit": "Ṣàtúnṣe",
    "send": "Fi ránṣẹ́",
    "yes": "Bẹ́ẹ̀ni",
    "no": "Bẹ́ẹ̀kọ́"
  },
  "nav": {
    "home": "Ilé",
    "help": "Ìrànlọ́wọ́",
    "account": "Àkáǹtì",
    "payments": "Ìsanwó",
    "clients": "Àwọn oníbàárà",
    "services": "Àwọn iṣẹ́",
    "vehicles": "Àwọn ọkọ̀"
  },
  "status": {
    "completed": "Ó parí",
    "cancelled": "A fagilé"
  },
  "service": {
    "delivery": "Ìfijíṣẹ́"
  }
}
